import { render } from "./WhatsAppTemplatesView.vue?vue&type=template&id=7a503739&scoped=true"
import script from "./WhatsAppTemplatesView.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplatesView.vue?vue&type=script&lang=js"

import "./WhatsAppTemplatesView.vue?vue&type=style&index=0&id=7a503739&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a503739"]])

export default __exports__